module.exports = __webpack_public_path__ + "media/images/favorite-red-icon-filled-d00b5c6e7c180384087ccecb664d5651.png";